module.exports = __webpack_public_path__ + "static/media/footer-post-signup-instagram.6c4481fe.svg";